import { Loader } from "@googlemaps/js-api-loader";

window.GoogleMapsLoader = Loader;
